const EsquireLogo = ({...props}) => {
    return <img src="./logo.png" alt="Esquire Logo" {...props}/>;
}

export default EsquireLogo;